import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { pagesApi } from '../services/api'
import AccreditationsPageContent from '../components/pages/AccreditationsPageContent'
import SubPagesGrid from '../components/pages/SubPagesGrid'
import PageMeta from '../components/seo/PageMeta'
import { PageSlugs } from '../constants/pageSlugs'

export default function AccreditationsPage() {
  const { t } = useTranslation()
  const [relatedPages, setRelatedPages] = useState([])
  const [showRelatedPages, setShowRelatedPages] = useState(false)

  useEffect(() => {
    pagesApi
      .getBySlug(PageSlugs.accreditations)
      .then(({ data }) => {
        const page = data.data || data
        setRelatedPages(data.related_pages || [])
        setShowRelatedPages(Boolean(page?.show_related_pages))
      })
      .catch(() => {})
  }, [])

  const title = t('accreditationsPage.heroTitle')
  const excerpt = t('accreditationsPage.heroExcerpt')

  return (
    <article className="header-offset">
      <PageMeta title={title} description={excerpt} path={`/pages/${PageSlugs.accreditations}`} />

      <div className="relative overflow-hidden gradient-brand py-16 text-white">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute -end-20 top-0 h-64 w-64 rounded-full bg-accent blur-3xl" />
        </div>
        <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6">
          <p className="mb-3 text-sm font-semibold uppercase tracking-widest text-accent">
            {t('accreditationsPage.heroLabel')}
          </p>
          <h1 className="text-4xl font-bold sm:text-5xl">{title}</h1>
          {excerpt && (
            <p className="mx-auto mt-4 max-w-2xl text-lg text-white/80">{excerpt}</p>
          )}
        </div>
      </div>

      <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6">
        <AccreditationsPageContent />
      </div>

      {showRelatedPages && (
        <SubPagesGrid pages={relatedPages} currentSlug={PageSlugs.accreditations} />
      )}
    </article>
  )
}
